import {TypeOption} from "@ngx-formly/core/lib/models";
import {AddArticleHeaderFormlyComponent} from "./add-article-header-formly/add-article-header-formly.component";

export const HomeFormlyType: TypeOption[] = [
  { name: 'add-article-header', component: AddArticleHeaderFormlyComponent },
];
